import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import BaseConfirmationDialog from '../../components/dialog/BaseConfirmationDialog';
import UserInitials from '../../components/userInitials/UserInitials';
import {getId, getName, getUserAvatar, isDefaultAvatar} from '../../utils/userUtility';

@inject('dialogStore', 'looperStore')
@observer
class ExitCreateModeActionsContainer extends Component {
    onSave = async () => {
        await this.props.onSave();
    };

    renderConfirmationContent = () => {
        const {looperStore} = this.props;
        const {loopedProject} = looperStore;
        const isAssignment = (loopedProject.userId && loopedProject.userId !== getId()) || loopedProject.groupId;
        const studentAvatar = loopedProject.owner && loopedProject.owner.avatar;
        return (
            <div className="studio-confirm-body">
                {isAssignment && !loopedProject.id && <div className="studio-confirm-images">
                    {isDefaultAvatar(getUserAvatar())
                        ? <UserInitials fullName={getName()} />
                        : <img className="user-avatar" src={getUserAvatar()} alt=""/>
                    }
                    <img className="user-avatar" src={studentAvatar} alt=""/>
                </div>}
                <div className="studio-confirm-message">
                    {loopedProject.id
                        ? <FormattedMessage id="studio.saveLessonDialog.message.unsavedChanges"/>
                        : isAssignment
                            ? <FormattedMessage id="studio.saveLessonDialog.message.unsavedAssignmentChanges"/>
                            : <FormattedMessage id="studio.saveLessonDialog.message.library"/>
                    }
                </div>
            </div>
        );
    };

    render() {
        const {dialogStore, onDiscard, buttonDisabled} = this.props;
        return (
            <BaseConfirmationDialog
                classes={{root: 'studio-confirm-modal', paper: 'studio-confirm-modal-paper'}}
                onDismiss={onDiscard}
                onSubmit={this.onSave}
                onOutsideClick={dialogStore.closeSaveLessonConfirm}
                open={dialogStore.showSaveLessonConfirm}
                contentSlot={this.renderConfirmationContent()}
                buttonText="yesSave"
                buttonDisabled={buttonDisabled}
                cancelButtonText="dontSave"
            />
        );
    }
}

export default ExitCreateModeActionsContainer;
